
import React from "react";
import { FormLabel, FormToggle, FormElement, FormInput, Button } from "../../../components/StyledElements";
import { useLiveEvents } from "../../../contexts/LiveEventsContext";

export const CoreDetails = ({ style = {}, onSelectTab = () => { } }) => {
  const { updatedDocumentSet, setUpdatedDocumentSet } = useLiveEvents();

  return (
    <div style={{ display: "flex", flexDirection: "column", ...style }}>
      <FormElement style={{ flexDirection: "row", display: "flex", alignItems: "center", gap: "10px" }}>
        <FormLabel label={`Published (${updatedDocumentSet?.published ? "Yes" : "No"})`} style={{ margin: 0 }} />
        <FormToggle
          checked={updatedDocumentSet?.published ?? false}
          onChange={(e) => {
            updatedDocumentSet.published = e.target.checked;
            setUpdatedDocumentSet({ ...updatedDocumentSet });
          }}
        />
      </FormElement>
      <FormElement>
        <FormLabel label="Public ID" />
        <FormInput disabled type="text" value={updatedDocumentSet?.public_id ?? ""} />
      </FormElement>
      <FormElement>
        <FormLabel label="Chroma Collection Name" />
        <FormInput type="text" disabled={true} value={updatedDocumentSet?.chroma_collection_name ?? ""} />
      </FormElement>
      <FormElement>
        <FormLabel label="Name" />
        <FormInput type="text" placeholder="Enter dataset name" value={updatedDocumentSet?.name ?? ""}
          onChange={(e) => {
          }}
        />
      </FormElement>
      <FormElement>
        <FormLabel label="Description" />
        <FormInput
          as="textarea"
          rows={5}
          placeholder="Enter event description"
          style={{ resize: "vertical" }}
          value={updatedDocumentSet?.description ?? ""}
          onChange={(e) => {
            updatedDocumentSet.description = e.target.value;
            setUpdatedDocumentSet({ ...updatedDocumentSet });
          }}
        />
      </FormElement>
    </div>
  );
};

export default CoreDetails;
